import { useTranslations } from 'next-intl';
import { type FC, useState } from 'react';
import { ProductLineUserGuide } from '@/app/components/icons/ProductLineUserGuide';
import { useIsScreen } from '@/app/hooks';
import type { FormTabType } from '@/app/types';
import { type Tutorial, TutorialPanel } from './TutorialPanel';

/**
 * 表单通用的、带样式的使用教程按钮组件
 * 提供一个链接，点击后在新窗口打开使用教程页面
 *
 * @returns {ReactNode} 使用教程按钮组件
 */
export const UserGuide: FC<{
  type: Extract<FormTabType, 'img2video' | 'character2video'>;
  tutorials: Tutorial[];
  onClickExample: (exampleIdx: number) => void;
  manualUrl?: string;
}> = ({ type, tutorials, onClickExample, manualUrl }) => {
  const t = useTranslations();
  const { isSmScreen } = useIsScreen();
  const [tutorialPanelOpen, setTutorialPanelOpen] = useState<boolean>(false);

  return (
    <>
      {manualUrl ? (
        <a
          id="user-guide-button"
          className="group flex h-full shrink-0 cursor-pointer items-center justify-center gap-2 rounded-[100px] px-3 text-white text-xs hover:bg-system-black24 lg:gap-1 lg:px-2"
          href={manualUrl}
          rel="noreferrer"
          target="_blank"
        >
          <ProductLineUserGuide className="shrink-0 text-lg" />
          <span className="opacity-80 group-hover:opacity-100">{t('create.userGuide')}</span>
        </a>
      ) : (
        <div
          id="user-guide-button"
          className="group flex h-full shrink-0 cursor-pointer items-center justify-center gap-2 rounded-[100px] px-3 text-white text-xs hover:bg-system-black24 lg:gap-1 lg:px-2"
          onClick={() => {
            setTutorialPanelOpen((prev) => !prev);
          }}
        >
          <ProductLineUserGuide className="shrink-0 text-lg" />
          <span className="opacity-80 group-hover:opacity-100">{t('create.userGuide')}</span>
        </div>
      )}
      <TutorialPanel
        open={tutorialPanelOpen}
        onClose={() => setTutorialPanelOpen(false)}
        onClickExample={onClickExample}
        tutorials={tutorials}
        type={type}
        showMask={isSmScreen}
      />
    </>
  );
};
